/* ============================== I C O N S ============================== */
import menubar from '@/components/Menu/Menu.vue';
import login from '@/views/Login/Login.vue';
// import router from './router';
/* ============================= E X P O R T ============================= */


export default {
    // router,
    /* ================== N A M E ================== */
    name: 'App',


    /* ================= P R O P S ================= */
    props: {

    },


    /* ============ C O M P O N E N T S ============ */
    components: {
        menubar,
        login
    },

    /* ================== D A T A ================== */
    data: function () {
        return {
            baseUrl: "",
            baseUrl_tools: "",
            baseUrl_public: ""

        }
    },

    mounted() {
        // console.log(process.env.NODE_ENV);
        // this.baseUrl = "https://sandbox.api.salonacme.com/"; // PRODUCTION
        this.baseUrl = "https://sandbox.api.salonacme.com/"; // LOCAL
        // this.baseUrl = "https://sandbox.api.salonacme.com/"; // TEST
        this.baseUrl_tools = this.baseUrl+"tools/";
        if (this.baseUrl.includes("sandbox.api.salonacme.com") || this.baseUrl.includes("192.168.") ) { /// production
            this.baseUrl_public = '';
        } else { /// test
            this.baseUrl_public = '/salon-acme-manager/';
        }
        // if(process.env.NODE_ENV === 'production')
        //     this.baseUrl = "/salon-acme-manager/";
        // else
        //     this.baseUrl = "/";
    }
}
